import { Action, Button } from '@foodsby/nutrient'
import currency from 'currency.js'
import React from 'react'

const PersonalizeButtons = ({
  buttonClassName,
  buttonOnClick,
  buttonText,
  cartLength,
  disableButton,
  disableLink,
  editing,
  editingClass,
  itemSubtotal,
  linkClassName,
  linkOnClick,
  linkText,
  orderSubtotal,
  visible,
}) => (
  <div className="checkout-button-container">
    {visible && (
      <div className="checkout-button-item">
        <Action className={linkClassName} disabled={disableLink} onClick={linkOnClick}>
          + {linkText}
        </Action>
      </div>
    )}
    <div>
      {itemSubtotal && ((!editing && cartLength >= 1) || (editing && cartLength >= 2)) && (
        <small className="itemTotal">
          Item Total:
          {` ${currency(itemSubtotal, {
            formatWithSymbol: true,
          }).format()}`}
        </small>
      )}
    </div>
    <div className={editingClass || ' checkout-button-item'}>
      <div>
        <Button
          className={buttonClassName || 'add-item-and-checkout'}
          disabled={disableButton}
          onClick={buttonOnClick}
        >
          {buttonText}
          {(orderSubtotal || itemSubtotal) && (
            <>
              <br />
              <small className="itemTotal">
                (Subtotal:
                {` ${
                  orderSubtotal
                    ? currency(orderSubtotal, {
                        formatWithSymbol: true,
                      }).format()
                    : currency(itemSubtotal, {
                        formatWithSymbol: true,
                      }).format()
                }`}
                )
              </small>
            </>
          )}
        </Button>
      </div>
    </div>
  </div>
)
export default PersonalizeButtons
